var GLOBO = GLOBO || {};
var FlowyOptionSelectors = FlowyOptionSelectors || {};
GLOBO.lang = null;
GLOBO.experiment = {};
GLOBO.selectors = {};

window.dataLayer = window.dataLayer || [];
function gtag() {dataLayer.push(arguments)}
gtag('js', new Date());
gtag('config', 'AW-763290327');

GLOBO.util = {
  getSizedImageUrl: function(src, size) {
    if (size === null) {
      return src;
    }
  
    if (size === 'master') {
      return src.replace(/http(s)?:/, '');
    }
  
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
    if (match) {null
      var prefix = src.split(match[0]);
      var suffix = match[0];
  
      var url = `${prefix[0]}_${size}${suffix}`;
      return url.replace(/http(s)?:/, '');
    } else {
      return null;
    }
  },
  getCurrentCountry: function() {
    if (JS_TRANSLATIONS.CURRENT_COUNTRY && typeof JS_TRANSLATIONS.CURRENT_COUNTRY !== 'undefined') {
      return JS_TRANSLATIONS.CURRENT_COUNTRY.toLowerCase();
    }
    if (URLSearchParams) {
      var params = new URLSearchParams(window.location.search);
      var countryFromParams = params.get('country');
      if (countryFromParams && typeof countryFromParams !== 'undefind') {
        return countryFromParams;
      }
    }
    var fromCache = GLOBO.lang.getCountryCodeFromStorage();
    if (fromCache) return fromCache;
    if (window.localStorage && window.localStorage.getItem('gdprCache')) {
      var parsed = JSON.parse(window.localStorage.getItem('gdprCache'));
      var countryDetectionStr = parsed.countryDetection;
      if (countryDetectionStr) {
        var countryDetection = JSON.parse(countryDetectionStr);
        if (countryDetection.country) {
          return countryDetection.country.toLowerCase();
        }
      }
    }
    if (window.location.hostname.includes('flowy.fr')) {
      return "fr";
    }
    if (window.location.hostname.includes('en.flowy.be')) {
      return "gb";
    }
    if (window.location.hostname.includes('flowyplants.de')) {
      return "de";
    }
    if (window.location.hostname.includes('flowyplants.nl')) {
      return "nl";
    }
    if (window.location.hostname.includes('flowy.be')) {
      return "be";
    }
    return null;
  },
  getBrowserLanguage() {
    var lang = window.navigator.language;
    if (lang && lang.length > 2) {
      return lang.substring(0, 2);
    }
    return lang;
  },
  getEstimatedDeliveryDate: function(size, timeOffset) {
    var country = GLOBO.util.getCurrentCountry();
    var currentDate = new Date();
    var UTCHours = currentDate.getUTCHours();
    if (UTCHours < 3) {
      currentDate = new Date(currentDate.getTime() - (UTCHours + 1) * 60 * 60 * 1000);
    }
    if (timeOffset > 0) {
      var offset = timeOffset;
      if (currentDate.getUTCDay() >= 5) {
        offset += (7 - currentDate.getUTCDay());
      }
      currentDate = new Date(currentDate.getTime() + offset * 24 * 60 * 60 * 1000);
    }
    var dayOfWeek = currentDate.getUTCDay();
    var daysToAdd = null;
    if (country === "be" || country === "nl" || country === "de") {
      daysToAdd = 3;
      if (dayOfWeek === 3) daysToAdd = 5;
      if (dayOfWeek === 4) daysToAdd = 5;
      if (dayOfWeek === 5) daysToAdd = 6;
      else if (dayOfWeek === 6) daysToAdd = 5;
    } else if (country === "fr" || country === "at") {
      daysToAdd = 4;
      if (dayOfWeek === 3) daysToAdd = 5;
      else if (dayOfWeek === 4) daysToAdd = 6;
      else if (dayOfWeek === 5) daysToAdd = 6;
      else if (dayOfWeek === 6) daysToAdd = 5;
    } else if (country === "gb") {
      if (currentDate.getMonth() === 3 && currentDate.getDate() < 7) {
        currentDate = new Date(currentDate.getTime() + (7 - currentDate.getDate()) * 24 * 60 * 60 * 1000);
      } else if (currentDate.getMonth() === 3 && currentDate.getDate() === 24) {
        currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
      } else if (currentDate.getMonth() === 4 && currentDate.getDate() <= 16) {
        currentDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
      }
      dayOfWeek = currentDate.getUTCDay();
      if (dayOfWeek === 2 || dayOfWeek === 3 || dayOfWeek === 4) {
        daysToAdd = 11 - dayOfWeek;
        if (size && size >= 100) daysToAdd += 1;
      } else if (dayOfWeek <= 1) {
        daysToAdd = 6 - dayOfWeek;
        if (size && size >= 100) daysToAdd += 2;
      } else {
        daysToAdd = 13 - dayOfWeek;
        if (size && size >= 100) daysToAdd += 2;
      }
    }
    if (daysToAdd) {
      var deliveryDate = new Date(currentDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000);
      return deliveryDate;
    }
    return null;
  },
  getEstimatedDeliveryDateStr: function(size_, timeOffset_) {
    var size = size_ || 0;
    var timeOffset = timeOffset_ || 0;
    var estimatedDeliveryDate = GLOBO.util.getEstimatedDeliveryDate(size, timeOffset);
    if (!estimatedDeliveryDate) return null;
    var lang = JS_TRANSLATIONS.CURRENT_LANG;
    if (!lang || typeof lang === "undefined") {
      if (window.location.href.includes('en.flowy.be') || GLOBO.lang.current === 'en') {
        lang = 'en';
      } else if (window.location.href.includes('flowyplants.de') || GLOBO.lang.current === 'de') {
        lang = 'de';
      } else if (window.location.href.includes('flowy.be/nl') || window.location.href.includes('flowyplants.nl') || GLOBO.lang.current === 'nl') {
        lang = 'nl';
      } else {
        lang = 'fr';
      }
    }
    return GLOBO.util.getDateStr(estimatedDeliveryDate, lang);
  },
  getEstimatedDeliveryDay: function() {
    var country = GLOBO.util.getCurrentCountry();
    var currentDate = new Date();
    var dayOfWeek = currentDate.getUTCDay();
    if (country === "nl" || country === "be") {
      dayOfWeek = dayOfWeek + 2;
      if (dayOfWeek > 6) dayOfWeek = dayOfWeek - 6;
      return dayOfWeek;
    } else if (country === "fr" || country === 'de' || country === 'at') {
      dayOfWeek = dayOfWeek + 4;
      if (dayOfWeek > 6) dayOfWeek = dayOfWeek - 6;
      return dayOfWeek;
    } else if (country === "gb") {
      if (dayOfWeek === 2 || dayOfWeek === 3) {
        return 3;
      } else {
        return 6;
      }
    }
    return null;
  },
  getHoursToOrder: function() {
    var currentDate = new Date();
    return (24 - currentDate.getUTCHours());
  },
  getDateStr: function(date, lang) {
    if (lang === "en") {
      return GLOBO.util.getEnglishDateStr(date);
    }
    var dayOfMonthStr = date.getUTCDate();
    var month = date.getUTCMonth();
    var monthStr = JS_TRANSLATIONS.DATES.MONTHS[month];
    var dayOfWeekStr = JS_TRANSLATIONS.DATES.DAYS[date.getUTCDay()];
    if (lang === "fr") {
      return (dayOfWeekStr + " " + dayOfMonthStr + " " + monthStr); 
    } else if (lang === "de") {
      return (dayOfWeekStr + ", " + dayOfMonthStr + " " + monthStr);
    } else if (lang === "nl") {
      return (dayOfWeekStr + ", " + dayOfMonthStr + " " + monthStr);
    } else {
      return null;
    }
  },
  getEnglishDateStr: function(date) {
    var dayOfMonthStr = date.getUTCDate();
    var month = date.getUTCMonth() + 1;
    var monthStr = "";
    var dayOfWeek = GLOBO.util.getDayOfWeekEnglishStrFromInt(date.getUTCDay());
    if (month === 1) monthStr = "January";
    if (month === 2) monthStr = "February";
    if (month === 3) monthStr = "March";
    if (month === 4) monthStr = "April";
    if (month === 5) monthStr = "May";
    if (month === 6) monthStr = "June";
    if (month === 7) monthStr = "July";
    if (month === 8) monthStr = "August";
    if (month === 9) monthStr = "September";
    if (month === 10) monthStr = "October";
    if (month === 11) monthStr = "November";
    if (month === 12) monthStr = "December";
    return (dayOfWeek + " " + monthStr + " " + dayOfMonthStr);
  },
  getDayOfWeekEnglishStrFromInt: function(day) {
    if (day === 0) return "Sunday";
    if (day === 1) return "Monday";
    if (day === 2) return "Tuesday";
    if (day === 3) return "Wednesday";
    if (day === 4) return "Thursday";
    if (day === 5) return "Friday";
    if (day === 6) return "Saturday";
    return null;
  },
  getUkShippingLeadDays: function() {
    var currentDate = new Date();
    var dayOfWeek = currentDate.getUTCDay();
    if ((dayOfWeek === 2 || dayOfWeek === 4) && currentDate.getUTCHours() < 4) {
      dayOfWeek = dayOfWeek - 1;
    }
    var shipsIn = 4 - dayOfWeek;
    if (dayOfWeek === 2 || dayOfWeek === 3) {
      // Ships next Mo. (Default next Th)
      shipsIn = 1 - dayOfWeek;
    }
    if (shipsIn <= 0) {
      shipsIn = shipsIn + 7;
    }
    return shipsIn;
  }
}

GLOBO.lazyLoad = {
  init: function() {
    document.addEventListener("DOMContentLoaded", function() {
      yall({
        lazyClass: "lazy",
        noPolyfill: true
      });
    });
  },
  run: function() {
    yall({
      lazyClass: "lazy",
      noPolyfill: true
    });
  }
}

GLOBO.lang = {
  current: null,
  countryMap: {
    'gb': {
      title: 'United Kingdom',
      currency: 'GBP',
      lang: 'en',
      flag: '🇬🇧'
    },
    'eu': {
      title: 'Europe',
      currency: 'EUR',
      lang: 'en',
      flag: '🇪🇺'
    },
    'be': {
      title: 'Belgique',
      currency: 'EUR',
      lang: 'fr',
      flag: '🇧🇪'
    },
    'be-fr': {
      title: 'Belgique',
      currency: 'EUR',
      lang: 'fr',
      flag: '🇧🇪'
    },
    'be-nl': {
      title: 'België',
      currency: 'EUR',
      lang: 'nl',
      flag: '🇧🇪'
    },
    'fr': {
      title: 'France',
      currency: 'EUR',
      lang: 'fr',
      flag: '🇫🇷'
    },
    'lu': {
      title: 'Luxembourg',
      currency: 'EUR',
      lang: 'fr',
      flag: '🇱🇺'
    },
    'de': {
      title: 'Deutschland',
      currency: 'EUR',
      lang: 'de',
      flag: '🇩🇪'
    },
    'at': {
      title: 'Österreich',
      currency: 'EUR',
      lang: 'de',
      flag: '🇦🇹'
    },
    'nl': {
      title: 'Nederland',
      currency: 'EUR',
      lang: 'nl',
      flag: '🇳🇱'
    }
  },
  getCountrySettings: function(countryCode, lang) {
    if (countryCode === 'be' && (lang === 'fr' || lang === 'nl')) {
      var locale = (countryCode + "-" + lang);
      return GLOBO.lang.countryMap[locale];
    }
    return GLOBO.lang.countryMap[countryCode];
  },
  init: function() {
    if (GLOBO.lang.current && typeof GLOBO.lang.current !== 'undefined') {
      document.body.setAttribute("data-lang", GLOBO.lang.current);
      GLOBO.trustpilot.setTpLanguage();
    }
    if (this.isCrawler()) {
      return;
    }
    if (window.location.href.includes('flowy-v1') || window.location.href.includes('dev-flowy')) {
      return;
    }
    var currencyFromParams = null;
    if (URLSearchParams) {
      var params = new URLSearchParams(window.location.search);
      var countryFromParams = params.get('country');
      if (params.get('currency')) {
        currencyFromParams = params.get('currency');
      }
      if (window.localStorage && countryFromParams) {
        window.localStorage.setItem('fl_country', countryFromParams);
      }
    }
    var countryCode = this.getCountryCodeFromStorage();
    var onEnDomain = window.location.href.includes('en.flowy.be');
    var onFrDomain = window.location.href.includes('flowy.fr');
    var onDeDomain = window.location.href.includes('flowyplants.de');
    var onNlDomain = window.location.href.includes('flowyplants.nl');
    var onBeNlDomain = window.location.href.includes('flowy.be/nl');
    var onEuEnDomain = window.location.href.includes('flowy.be/en');
    var currentCurrency = document.body.getAttribute('data-currency');
    if (onEnDomain) {
      // document.cookie = "cart_currency=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      // document.cookie = "cart_currency=GBP; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
      document.cookie = "currency=" + (currencyFromParams || "GBP") + "; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
      // countryCode = 'gb';
      if (!countryCode || currencyFromParams === "GBP") {
        countryCode = 'gb';
        window.localStorage.setItem('fl_country', countryCode);
      }
      document.body.setAttribute("data-country", countryCode);
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, 'en');
      if (countrySettings && currentCurrency !== countrySettings.currency) {
        return GLOBO.lang.switchTo(countryCode, countrySettings.lang, countrySettings.currency, true);
      }
      return this.setCountryName(countryCode, countrySettings.lang);
    } else if (onFrDomain) {
      document.cookie = "currency=EUR; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
      countryCode = 'fr';
      window.localStorage.setItem('fl_country', countryCode);
      document.body.setAttribute("data-country", countryCode);
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, 'fr');
      if (countrySettings && currentCurrency !== countrySettings.currency) {
        return GLOBO.lang.switchTo(countryCode, countrySettings.lang, countrySettings.currency, true);
      }
      return this.setCountryName(countryCode, countrySettings.lang);
    } else if (onDeDomain) {
      if (countryCode !== 'at') {
        countryCode = 'de';
      }
      window.localStorage.setItem('fl_country', countryCode);
      document.body.setAttribute("data-country", countryCode);
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, 'de');
      if (countrySettings && currentCurrency !== countrySettings.currency) {
        return GLOBO.lang.switchTo(countryCode, countrySettings.lang, countrySettings.currency, true);
      }
      return this.setCountryName(countryCode, countrySettings.lang);
    } else if (onNlDomain || onBeNlDomain) {
      countryCode = onBeNlDomain ? 'be' : 'nl';
      window.localStorage.setItem('fl_country', countryCode);
      document.body.setAttribute("data-country", countryCode);
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, 'nl');
      if (countrySettings && currentCurrency !== countrySettings.currency) {
        return GLOBO.lang.switchTo(countryCode, countrySettings.lang, countrySettings.currency, true);
      }
      return this.setCountryName(countryCode, countrySettings.lang);
    } else if (onEuEnDomain) {
      if (!countryCode) {
        countryCode = 'eu';
      }
      window.localStorage.setItem('fl_country', countryCode);
      document.body.setAttribute("data-country", countryCode);
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, 'en');
      if (countrySettings && currentCurrency !== countrySettings.currency) {
        return GLOBO.lang.switchTo(countryCode, countrySettings.lang, countrySettings.currency, true);
      }
      return this.setCountryName(countryCode, countrySettings.lang);
    }
    
    // Not en/fr/de domain.
    if (countryCode === 'gb') {
      return GLOBO.lang.switchTo(countryCode, 'en', 'GBP', true);
    } else if (countryCode === 'de' || countryCode === 'at') {
      return GLOBO.lang.switchTo(countryCode, 'de', 'EUR', true);
    } else if (countryCode === 'nl') {
      return GLOBO.lang.switchTo(countryCode, 'nl', 'EUR', true);
    }
    if (countryCode) {
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, GLOBO.util.getBrowserLanguage());
      if (countrySettings && currentCurrency !== countrySettings.currency) {
        return GLOBO.lang.switchTo(countryCode, countrySettings.lang, countrySettings.currency, true);
      }
      if (countrySettings) {
        document.body.setAttribute("data-country", countryCode);
        return this.setCountryName(countryCode, countrySettings.lang);
      }
    }
    // No saved country.
    return this.getUserCountry(onEnDomain, onDeDomain, onNlDomain, onBeNlDomain, onEuEnDomain);
  },
  isCrawler: function() {
    var botPattern = "(Googlebot\/|googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
    var re = new RegExp(botPattern, 'i');
    var userAgent = navigator.userAgent; 
    if (re.test(userAgent)) {
      return true;
    }
    return false;
  },
  getCountryCodeFromStorage: function() {
    if (window.localStorage && window.localStorage.getItem('fl_country')) {
      return window.localStorage.getItem('fl_country');
    }
    return null;
  },
  setCountryName: function(countryCode, lang) {
    if (!countryCode) return;
    var countrySettings = GLOBO.lang.getCountrySettings(countryCode, lang);
    if (countrySettings && jQuery('.selected-country-name').length) {
      jQuery('.selected-country-name').html(countrySettings.title);
    }
    if (countrySettings && jQuery('.selected-country-flag').length) {
      jQuery('.selected-country-flag').html(countrySettings.flag);
    }
  },
  getUserCountry: function(onEnDomain, onDeDomain, onNlDomain, onBeNlDomain, onEuEnDomain) {
    if (window.sessionStorage.getItem('geocheck')) {
      if (onEnDomain) {
        GLOBO.lang.setCountryName('gb', 'en');
      } else if (onDeDomain) {
        GLOBO.lang.setCountryName('de', 'de');
      } else if (onNlDomain) {
        GLOBO.lang.setCountryName('nl', 'nl');
      } else if (onBeNlDomain) {
        GLOBO.lang.setCountryName('be', 'nl');
      } else if (onEuEnDomain) {
        GLOBO.lang.setCountryName('eu', 'en');
      } else {
        GLOBO.lang.setCountryName('eu');
      }
      return;
    }
    var apiKey = 'b8fbc86ef33a1aa775591eb71af2f290';
    var url = 'https://api.ipstack.com/check?access_key='
    url += apiKey;
    url += "&fields=country_code";
    jQuery.get(url).done(function(data) {
      var countryCode = (data && data.country_code) ? data.country_code.toLowerCase() : null;
      var browserLang = GLOBO.util.getBrowserLanguage();
      var countrySettings = GLOBO.lang.getCountrySettings(countryCode, browserLang);
      if (!countryCode || !countrySettings) {
        if (onEnDomain) {
          GLOBO.lang.setCountryName('gb', 'en');
        } else if (onDeDomain) {
          GLOBO.lang.setCountryName('de', 'de');
        } else if (onNlDomain) {
          GLOBO.lang.setCountryName('nl', 'nl');
        } else if (onBeNlDomain) {
          GLOBO.lang.setCountryName('be', 'nl');
        } else if (onEuEnDomain) {
          GLOBO.lang.setCountryName('eu', 'en');
        } else {
          GLOBO.lang.setCountryName('eu');
        }
      } else {
        if ((countryCode === 'de' || countryCode === 'at') && !onDeDomain) {
          // Switch.
          GLOBO.lang.switchTo(countryCode, 'de', 'EUR', true);
        } else if (countryCode === 'gb' && !onEnDomain) {
          // Switch.
          GLOBO.lang.switchTo(countryCode, 'en', 'GBP', true);
        } else if (countryCode === 'nl' && !onNlDomain) {
          // Switch.
          GLOBO.lang.switchTo(countryCode, 'nl', 'EUR', true);
        } else if (countryCode === 'be' && browserLang === 'nl' && !onBeNlDomain) {
          // Switch.
          GLOBO.lang.switchTo(countryCode, 'nl', 'EUR', true);
        } else if (onDeDomain) {
          GLOBO.lang.setCountryName((countryCode === 'at' ? 'at' : 'de'), 'de');
        } else if (onEnDomain) {
          GLOBO.lang.setCountryName('gb', 'en');
        } else if (onNlDomain) {
          GLOBO.lang.setCountryName('nl', 'nl');
        } else if (onBeNlDomain) {
          GLOBO.lang.setCountryName('be', 'nl');
        } else if (onEuEnDomain) {
          GLOBO.lang.setCountryName(countryCode, 'en');
        } else {
          GLOBO.lang.setCountryName(countryCode);
        }
      }
      window.sessionStorage.setItem('geocheck', true);
    });
  },
  switchTo: function(countryCode, lang, currency, auto) {
    if (typeof ga !== "undefined" && ga !== null && ga) {
      ga('send', 'event', 'Change Country', auto ? "auto" : "click", (countryCode + "_" + (lang || "")), 0);
    }
    var onEnDomain = window.location.href.includes('en.flowy.be');
    var onFrDomain = window.location.href.includes('flowy.fr');
    var onDeDomain = window.location.href.includes('flowyplants.de');
    var onNlDomain = window.location.href.includes('flowyplants.nl');
    var onBeNlDomain = window.location.href.includes('flowy.be/nl');
    var onEuEnDomain = window.location.href.includes('flowy.be/en');
    var currentDomain = window.location.hostname.replace("www.", "");
    if (onBeNlDomain) {
      currentDomain = currentDomain + "/nl"
    } else if (onEuEnDomain) {
      currentDomain = currentDomain + "/en"
    }
    var currentCurrency = document.body.getAttribute('data-currency');
    var domainChange = false;
    if (onEnDomain && lang !== 'en') {
      domainChange = true;
    } else if (!onEnDomain && lang === 'en' && countryCode === 'gb') {
      domainChange = true;
    } else if (onEuEnDomain && (lang !== 'en' || countryCode === 'gb')) {
      domainChange = true;
    } else if (!onEuEnDomain && lang === 'en' && countryCode !== 'gb') {
      domainChange = true;
    } else if (onDeDomain && lang !== 'de') {
      domainChange = true;
    } else if (!onDeDomain && lang === 'de') {
      domainChange = true;
    } else if ((onNlDomain || onBeNlDomain) && lang !== 'nl') {
      domainChange = true;
    } else if (!onBeNlDomain && lang === 'nl' && countryCode === 'be') {
      domainChange = true;
    } else if (!onNlDomain && lang === 'nl') {
      domainChange = true;
    } else if (onFrDomain && countryCode === 'be') {
      domainChange = true;
    }
    if (currentCurrency !== currency) {
      domainChange = true;
    }
    if (window.localStorage) {
      window.localStorage.setItem('fl_country', countryCode);
    }
    var params = new URLSearchParams(window.location.search);
    params.delete('country');
    params.set('country', countryCode);
    if (currency === 'EUR' || currency === 'GBP') {
      params.set('currency', currency);
    } else if (countryCode === 'gb') {
      params.set('currency', 'GBP');
    } else {
      params.set('currency', 'EUR');
    }
    var url = window.location.href;
    var splitUrl = window.location.href.split('?');
    var newLocation = splitUrl[0] + "?" + params.toString();
    if (domainChange && URLSearchParams && countryCode) {
      if (onEuEnDomain && (lang !== 'en' || countryCode === 'gb')) {
        var newDomain = 'flowy.be';
        if (countryCode === 'fr') {
          newDomain = 'flowy.fr';
        } else if (countryCode === 'de' || countryCode === 'at') {
          newDomain = 'flowyplants.de';
        } else if (countryCode === 'nl') {
          newDomain = 'flowyplants.nl';
        } else if (countryCode === 'be' && lang === 'nl') {
          newDomain = 'flowy.be/nl';
        } else if (countryCode === 'gb') {
          newDomain = 'en.flowy.be';
        }
        newLocation = newLocation.replace(currentDomain, newDomain);
      } else if (url.includes('en.flowy.be') && (lang !== 'en' || countryCode === 'eu')) {
        var newDomain = 'flowy.be';
        if (countryCode === 'fr') {
          newDomain = 'flowy.fr';
        } else if (countryCode === 'de' || countryCode === 'at') {
          newDomain = 'flowyplants.de';
        } else if (countryCode === 'nl') {
          newDomain = 'flowyplants.nl';
        } else if (countryCode === 'be' && lang === 'nl') {
          newDomain = 'flowy.be/nl';
        } else if (countryCode !== 'gb' && lang === 'en') {
          newDomain = 'flowy.be/en';
        }
        newLocation = newLocation.replace(currentDomain, newDomain);
      } else if (url.includes('flowyplants.de') && lang !== 'de') {
        var newDomain = 'flowy.be';
        if (countryCode === 'fr') {
          newDomain = 'flowy.fr';
        } else if (countryCode === 'gb') {
          newDomain = 'en.flowy.be';
        } else if (countryCode === 'nl') {
          newDomain = 'flowyplants.nl';
        } else if (countryCode === 'be' && lang === 'nl') {
          newDomain = 'flowy.be/nl';
        } else if (lang === 'en') {
          newDomain = 'flowy.be/en';
        }
        newLocation = newLocation.replace(currentDomain, newDomain);
      } else if ((onNlDomain || onBeNlDomain) && lang !== 'nl') {
        var newDomain = 'flowy.be';
        if (countryCode === 'fr') {
          newDomain = 'flowy.fr';
        } else if (countryCode === 'de' || countryCode === 'at') {
          newDomain = 'flowyplants.de';
        } else if (countryCode === 'gb') {
          newDomain = 'en.flowy.be';
        } else if (lang === 'en') {
          newDomain = 'flowy.be/en';
        }
        newLocation = newLocation.replace(currentDomain, newDomain);
      } else if (onFrDomain && lang !== 'fr') {
        var newDomain = 'flowy.be';
        if (countryCode === 'nl') {
          newDomain = 'flowyplants.nl';
        } else if (countryCode === 'be' && lang === 'nl') {
          newDomain = 'flowy.be/nl';
        } else if (countryCode === 'de' || countryCode === 'at') {
          newDomain = 'flowyplants.de';
        } else if (countryCode === 'gb') {
          newDomain = 'en.flowy.be';
        } else if (lang === 'en') {
          newDomain = 'flowy.be/en';
        }
        newLocation = newLocation.replace(currentDomain, newDomain);
      } else if (!url.includes('en.flowy.be') && lang === 'en' && countryCode === 'gb') {
        newLocation = newLocation.replace(currentDomain, 'en.flowy.be');
      } else if (!onEuEnDomain && lang === 'en') {
        newLocation = newLocation.replace(currentDomain, 'flowy.be/en');
      } else if (!url.includes('flowyplants.de') && lang === 'de') {
        newLocation = newLocation.replace(currentDomain, 'flowyplants.de');
      } else if (!onBeNlDomain && lang === 'nl' && countryCode === 'be') {
        newLocation = newLocation.replace(currentDomain, 'flowy.be/nl');
      } else if (!onNlDomain && lang === 'nl') {
        newLocation = newLocation.replace(currentDomain, 'flowyplants.nl');
      } else if (onFrDomain && countryCode === 'be' && lang === 'fr') {
        newLocation = newLocation.replace(currentDomain, 'flowy.be');
      }
      // window.location.href = newLocation;
      // return;
    }
    window.location.href = newLocation;
    return;
    GLOBO.lang.pendingSwitch = {
      lang: lang,
      countryCode: countryCode,
      currency: currency
    };
    if (typeof Weglot !== 'undefined' && Weglot.initialized) {
      GLOBO.lang.makeSwitch();
    }
  },
  makeSwitch: function() {
    if (GLOBO.lang.pendingSwitch === false || !GLOBO.lang.pendingSwitch.lang || !GLOBO.lang.pendingSwitch.countryCode) {
      return;
    }
    Weglot.switchTo(GLOBO.lang.pendingSwitch.lang);
    this.setCountryName(GLOBO.lang.pendingSwitch.countryCode, GLOBO.lang.pendingSwitch.lang);
    GLOBO.lang.pendingSwitch = false;
  },
  pendingSwitch: false
}

GLOBO.swatchV2 = {
  selectedPotType: -1,
  selectedColorElement: null,
  lastSelectedColor: 'WG',
  onHover: function(value, element) {
    var potSelectionContainer = element.closest('#potColorSelection');
    var potColorElement = potSelectionContainer.querySelector('.pot-color');
    if (!potColorElement.dataset.original) {
      potColorElement.dataset.original = potColorElement.innerHTML;
    }
    potColorElement.innerHTML = value;

    var colorSwatches = potSelectionContainer.querySelector('.pot-colors-swatch');
    var onMouseLeave = function() {
      if (potSelectionContainer.dataset.selectionValue) {
        potColorElement.innerHTML = potSelectionContainer.dataset.selectionValue;
      } else {
        potColorElement.innerHTML = potColorElement.dataset.original;
      }
      colorSwatches.removeEventListener("mouseleave", onMouseLeave);
    }
    colorSwatches.addEventListener("mouseleave", onMouseLeave);
  },
  onSelect: function(element) {
    if (!element) return;
    this.selectedColorElement = element;
    var value = element.dataset.optionValue;
    var potSelectionContainer = element.closest('#potColorSelection');
    var optionIndex = potSelectionContainer.dataset.optionIndex;

    if (this.selectedPotType === -1) {
      this.selectedPotType = 1;
    }
    var optionValue = value;
    if (this.selectedPotType === 2) {
      // Venice.
      var potColor = element.dataset.potColor;
      var veniceElement = potSelectionContainer.querySelector('.pot-color-swatch-venice[data-pot-color="' + potColor + '"]');
      if (veniceElement) {
        optionValue = veniceElement.dataset.optionValue;
      }
    }
    if (element.dataset.potColor !== "NONE") {
      this.lastSelectedColor = element.dataset.potColor;
    }

    var productAddToCartForm = document.getElementById('productAddToCartForm');
    var optionSelectors = productAddToCartForm.querySelectorAll('.single-option-selector');
    if (optionSelectors.length > optionIndex) {
      optionSelectors[optionIndex].value = optionValue;
      optionSelectors[optionIndex].dispatchEvent(new Event('change'));
    }
  },
  onSelectPotType: function(element) {
    var potTypeId = parseInt(element.dataset.potTypeId);
    var potTypeSelectInputs = document.querySelectorAll('.product-options-wrapper .pot-type.selected');
    for (var i = 0; i < potTypeSelectInputs.length; i++) {
      potTypeSelectInputs[i].classList.remove('selected');
    }
    element.classList.toggle('selected');
    var potTypeWrappers = document.querySelectorAll('.product-options-wrapper .pot-type-wrapper');
    for (var i = 0; i < potTypeWrappers.length; i++) {
      potTypeWrappers[i].classList.remove('muted');
      potTypeWrappers[i].classList.remove('selected');
      if (potTypeId === 0 && potTypeWrappers[i].dataset.potTypeId !== "0") {
        potTypeWrappers[i].classList.add('muted');
      } else if (potTypeId !== 0 && potTypeWrappers[i].dataset.potTypeId === "0") {
        potTypeWrappers[i].classList.add('muted');
      } else if (element.dataset.potTypeId === potTypeWrappers[i].dataset.potTypeId) {
        potTypeWrappers[i].classList.add('selected');
      }
    }
    if (this.selectedPotType === potTypeId) {
      return;
    }
    if (potTypeId === 0) {
      this.selectedPotType = potTypeId;
      this.onSelect(document.querySelector('.product-options-wrapper .pot-color-swatch[data-pot-color="NONE"]'));
    } else if (this.selectedPotType === 0) {
      this.selectedPotType = potTypeId;
      this.onSelect(document.querySelector(`.product-options-wrapper .pot-color-swatch[data-pot-color="${this.lastSelectedColor}"]`));
    } else if (this.selectedColorElement) {
      this.selectedPotType = potTypeId;
      this.onSelect(this.selectedColorElement);
    } else if (potTypeId !== 0 && !this.selectedColorElement) {
      this.selectedPotType = potTypeId;
      this.onSelect(document.querySelector(`.product-options-wrapper .pot-color-swatch[data-pot-color="${this.lastSelectedColor}"]`));
    }
  }
}

GLOBO.swatch = {
  listener: null,
  init: function() {
    if (this.listener) {
      this.listener.off('change', this.onSwatchChange);
    }
    if (jQuery('.swatch :radio').length > 0) {
      this.listener = jQuery('.swatch :radio').on('change', this.onSwatchChange);
    }
  },
  onSwatchChange: function(e) {
    var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
    var optionValue = jQuery(this).val();
    jQuery(e.target)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
  },
  onHover: function(value, element) {
    var container = $(element).closest('.swatch-container');
    var potColorElement = container.find('.pot-color');
    if (!potColorElement.attr('data-original')) {
      potColorElement.attr('data-original', potColorElement.html());
    }
    potColorElement.removeClass("text-danger");
    potColorElement.addClass("text-muted");
    potColorElement.html(value);
    potColorElement.attr('data-selected', true);
    var onMouseLeave = function() {
      if (container.find('.swatch input:checked').length) {
        potColorElement.html(container.find('.swatch input:checked').val());
      } else {
        if (potColorElement.attr('data-original')) {
          if (potColorElement.attr('data-original').includes(' ')) {
            potColorElement.html(potColorElement.attr('data-original'));
          } else {
            potColorElement.html(container.find('.swatch-pot-icon').length + " " + potColorElement.attr('data-original'));
          }
        } else {
          potColorElement.html(container.find('.swatch-pot-icon').length + " Couleurs");
        }
      }
      container.find('.swatch').off("mouseleave", onMouseLeave);
    };
    container.find('.swatch').on("mouseleave", onMouseLeave);
  },
  cardSelectCallback: function(variant, selector) {
    if (variant) {
      var colors = ["Couleurs", "Colours", "Colors", "Farben"];
      var card = jQuery('#' + selector.domIdPrefix).closest('.product-card');
      if (!card.length) {
        // Cart pot selector.
        card = jQuery('#' + selector.domIdPrefix).closest('.cart-item');
      }
      card.addClass('init');
      var poColorElement = card.find(".pot-color");
      if (poColorElement.attr('data-selected') === "false") {
      // if (poColorElement.html().endsWith("Couleurs") || colors.includes(poColorElement.html()) || poColorElement.html().endsWith("Colors")) {
        // var potCount = card.find('.swatch-pot-icon').length > 0 ? card.find('.swatch-pot-icon').length : poColorElement.attr('data-variant-count');
        // poColorElement.html(potCount + " Couleurs");
        return;
      }

      card.addClass('variant-selected');

      if (variant.id) {
        var urlsEls = card.find('a.product-url');
        var url = urlsEls.attr('href');
        url += "?variant=" + variant.id;
        urlsEls.attr('href', url);
      }

      if (variant.featured_image) {
        var img = card.find(".selected-variant-image");
        var originalSrc = variant.featured_image.src;
        var src = GLOBO.util.getSizedImageUrl(originalSrc, 'x750') || originalSrc;
        img.addClass('loading');
        img.attr('src', src).on('load', function() {
          img.removeClass('loading');
        });
      }

      if (variant.available) {
        card.find('button[type="submit"]').removeClass('disabled').removeAttr('disabled').html(JS_TRANSLATIONS.add_cart).fadeTo(200,1);
      } else {
        card.find('button[type="submit"]').html(JS_TRANSLATIONS.out_of_stock).addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
      }
      var currency = "€";
      if (Shopify.currency && Shopify.currency.active === 'GBP') {
        currency = "£";
      }
      var priceElement = card.find('.price');
      var updateBtnEl = card.find('.update-pot-btn');
      var newPrice = variant.price;
      if (!priceElement.length) {
        priceElement = card.find('.pot-extra-cost');
        if (priceElement.length && priceElement[0].getAttribute('data-current-price')) {
          newPrice = newPrice - parseInt(priceElement[0].getAttribute('data-current-price'));
        }
      }
      if (priceElement.length) {
        priceElement.html(Shopify.formatMoney(newPrice, `${currency}\{\{amount_with_comma_separator\}\}`));
      }
      if (updateBtnEl.length) {
        // Update btn if in cart.
        updateBtnEl.attr('data-new-variant', variant.id);
        updateBtnEl.prop("disabled", updateBtnEl[0].getAttribute('data-previous-variant') === variant.id.toString());
      }
      
      var pairDiscountEl = card.find('.pair-discount-price');
      if (pairDiscountEl.length) {
        var discountSource = 'data-discounted-price';
        if (variant.sku.endsWith('-P') || variant.sku.endsWith('-RP')) {
          discountSource = 'data-potted-discounted-price';
        }
        var discountedPrice = parseInt(pairDiscountEl[0].getAttribute(discountSource));
        if (discountedPrice) {
          pairDiscountEl.html(Shopify.formatMoney(discountedPrice, `${currency}\{\{amount_with_comma_separator\}\}`));
        }
      }

      if (variant.option1) {
        poColorElement.html(variant.option1);
        poColorElement.removeClass("text-danger");
        poColorElement.addClass("text-muted");
      }
      var parent = card.hasClass("cart-item") ? card : jQuery('#' + selector.domIdPrefix).closest('form');
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = parent.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
    }
  }
}

GLOBO.tooltips = {
  init: function() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
  }
}

GLOBO.gliders = {
  init: function() {
    jQuery(function($) {
      GLOBO.gliders.initSocialPics();
      GLOBO.gliders.initFeatured();
      GLOBO.gliders.initMostViewed();
      GLOBO.gliders.initRelated();
      GLOBO.gliders.initReviews();
    });
  },
  initSocialPics: function() {
    if (!document.querySelector('.social-pics .glider')) return;
    new Glider(document.querySelector('.social-pics .glider'), {
      slidesToShow: 2,
      slidesToScroll: 1,
      draggable: true,
      arrows: {
        prev: '.social-pics .arrow-prev',
        next: '.social-pics .arrow-next',
      },
      responsive: [{
        breakpoint: 768,
        rewind: true,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1200,
        rewind: true,
        settings: {
          slidesToShow: 4
        }
      }]
    });
  },
  initMostViewed: function() {
    if (!document.querySelector('.most-viewed .glider')) return;
    var mostViewedSlider = new Glider(document.querySelector('.most-viewed .glider'), {
      slidesToShow: 1.22,
      slidesToScroll: 1,
      draggable: true,
      arrows: {
        prev: '.most-viewed .arrow-prev', next: '.most-viewed .arrow-next',
      },
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      }]
    });
  },
  initFeatured: function() {
    if (!document.querySelector('.featured-products .glider')) return;
    var featuredProductsSlider = new Glider(document.querySelector('.featured-products .glider'), {
      slidesToShow: 1.1,
      slidesToScroll: 1,
      draggable: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            draggable: false,
            rewind: true,
            arrows: {
              prev: '.featured-products .arrow-prev',
              next: '.featured-products .arrow-next',
            },
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            draggable: false,
            rewind: true,
            arrows: {
              prev: '.featured-products .arrow-prev',
              next: '.featured-products .arrow-next',
            },
          }
        }
      ]
    });
  },
  initRelated: function() {
    if (!document.querySelector('.related-products .glider')) return;
    var relatedProductsSlider = new Glider(document.querySelector('.related-products .glider'), {
      slidesToShow: 1.22,
      slidesToScroll: 1,
      draggable: true,
      arrows: {
        prev: '.related-products .arrow-prev', next: '.related-products .arrow-next',
      },
      responsive: [{
        breakpoint: 768,
        rewind: true,
        settings: {
          slidesToShow: 3.2
        }
      }]
    });
  },
  initReviews: function() {
    if (document.querySelector('.reviews-desk .glider')) {
      var reviewsDesk = new Glider(document.querySelector('.reviews-desk .glider'), {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        rewind: true,
        arrows: {
          prev: '.reviews .arrow-prev',
          next: '.reviews .arrow-next',
        }
      });
    }
    if (document.querySelector('.reviews-mobile .glider')) {
      var reviews = new Glider(document.querySelector('.reviews-mobile .glider'), {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: '.reviews-mobile .dots',
      });
    }
  }
}

GLOBO.collectionLoader = {
  init: function() {
    if ($(".g_more_products").length) {
      var i = !1;
      gSRC = $(".g_more_products").last(), gURL = $(".g_more_products a").last().attr("href");
      !i && gSRC.length > 0 && $.ajax({
        type: "GET",
        url: gURL,
        beforeSend: function() {
          i = !0, jQuery(".g_more_products a").addClass("animate-loading")
        },
        success: function(e) {
          var t = $(e).find(".products-grid .product-card-wrapper");
          if (customFilters && customFilters.active && customFilters.addProducts) {
            customFilters.addProducts(t, e);
            GLOBO.swatch.init();
            var nextUrl = $(".g_more_products a").last().attr("href");
            if ($(e).find('.g_more_products').length && nextUrl && nextUrl !== gURL) {
              GLOBO.collectionLoader.init();
            }
            return;
          }
        },
        dataType: "html"
      });
    }
  },
  sortBy: function(e) {
    Shopify.queryParams = {};
    if (location.search.length) {
      var params = location.search.substr(1).split('&');
  
      for (var i = 0; i < params.length; i++) {
        var keyValue = params[i].split('=');
  
        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }
    var value = e.getAttribute('data-filter-value');

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  }
}

GLOBO.intercom = {
  checkUrl: function() {
    var url = window.location.href;
    if (url.includes('showChat')) {
      this.showChat();
    }
  },
  showChat: function(e) {
    if (typeof e !== "undefined") {
      e.preventDefault();
    }
    if (window.intercomSettings && Intercom) {
      Intercom('show');
    } else {
      setTimeout(function () {
        if (!window.intercomSettings) {
          GLOBO.intercom.showChat();
        } else {
          Intercom('show');
        }
      }, 500);
    }
    return false;
  }
}

GLOBO.trustpilot = {
  API_KEY: "xbEIoYbhW6NreSkq3J3eCclV04nmzGv1",
  REVIEWS_SUMMARY_URL: "https://api.trustpilot.com/v1/product-reviews/business-units/5d9da09b76882e0001e9ee6a",
  REVIEWS_URL: "https://api.trustpilot.com/v1/product-reviews/business-units/5d9da09b76882e0001e9ee6a/reviews",
  getReviewsSummary: function(skuList, alsoGetReviews) {
    var url = this.REVIEWS_SUMMARY_URL + "?apikey=" + this.API_KEY + "&sku=" + skuList;
    jQuery.get(url).done(function(data) {
      if (!data || !data.starsAverage || data.starsAverage < 3.9 || data.numberOfReviews.total < 10) {
        jQuery(".product-summary #tp-service-reviews.trustpilot-widget-preload").show();
        return;
      }
      jQuery(".product-summary #tp-product-reviews.trustpilot-widget-preload").show();
      var productReviewsEl = jQuery(".product-page .product-reviews");
      if (productReviewsEl.length > 0) {
        if (data && data.numberOfReviews && data.numberOfReviews.total > 1) {
          productReviewsEl.css('height', '800px');
        }
        productReviewsEl.show();
      }
      if (alsoGetReviews === true) {
        return GLOBO.trustpilot.getReviews(skuList);
      }
    });
  },
  getReviews: function(skuList) {
    var url = this.REVIEWS_URL + "?apikey=" + this.API_KEY + "&sku=" + skuList + "&stars=4,5&language=fr";
    jQuery.get(url).done(function(data) {
    });
  },
  setTpLanguage: function() {
    if (!GLOBO.lang.current || !window.Trustpilot) {
      return;
    }
    var tpWidgets = document.querySelectorAll(".trustpilot-widget-preload");
    var tpLocale; // Module lang.
    var tpLang; // Review lang.
    if (GLOBO.lang.current === 'fr') {
      tpLocale = 'fr-FR';
      tpLang = 'fr';
    } else if (GLOBO.lang.current === 'de') {
      tpLocale = 'de-DE';
      tpLang = 'en'; // TODO: change once we have reviews.
    } else if (GLOBO.lang.current === 'nl') {
      tpLocale = 'nl-NL';
      tpLang = 'en'; // TODO: change once we have reviews.
    } else {
      tpLocale = 'en-GB';
      tpLang = 'en';
    }
    for (var i = 0; i < tpWidgets.length; i++) {
      var tpWidget = tpWidgets[i];
      if (tpWidget.getAttribute('data-locale') !== tpLocale) {
        tpWidget.setAttribute('data-locale', tpLocale);
        tpWidget.setAttribute('data-review-languages', tpLang);
      }
      window.Trustpilot.loadFromElement(tpWidget);
    }
  }
}

GLOBO.header = {
  toShow: null,
  init: function() {
    $(function(){
      const debounceMenu = 500;
      const animationTime = 300;
      let leftMenu;

      const clearTimeouts = function() {
        clearTimeout(leftMenu)
      }

      const showLevel3Menu = function(lastActive, nextActive) {
        var expanding = $('.submenu-last-level.expanding');
        if (expanding.length) {
          lastActive = expanding;
        } else if (lastActive.hasClass('closing')) {
          lastActive = null;
        }
        if (!lastActive || !lastActive.length) {
          GLOBO.header.toShow = nextActive;
          setTimeout(function() {
            if ($('.nav-item:hover').length === 0) return;
            GLOBO.header.toShow.addClass('expanding');
            GLOBO.header.toShow.slideDown(animationTime, function() {
              $(this).addClass('active');
              $(this).removeClass('expanding');
              $(this).css('display', '');
            });
          }, debounceMenu);
        } else {
          if (expanding) {
            setTimeout(function() {
              expanding.removeClass('active');
            }, animationTime);
          }
          lastActive.removeClass('active');
          nextActive.addClass('active');
        }
      }

      const closeLevel3Menu = function() {
        var lastActiveSub = $('.navbar').find('.submenu-last-level.active');
        var expanding = $('.submenu-last-level.expanding');
        lastActiveSub.addClass('closing');
        lastActiveSub.slideUp(animationTime, function() {
          $(this).removeClass('active');
          $(this).removeClass('closing');
          $(this).css('display', '');
        });

        var lastActive = $('.navbar').find('.menu-second-level .nav-item.active');
        lastActive.removeClass('active');

        if (!lastActiveSub.length && expanding.length) {
          setTimeout(closeLevel3Menu, animationTime);
        }
      }

      const onTopLevelHover = function(e) {
        var lastActive = $('.navbar').find('.nav-link.active');
        var active = $(this);
        lastActive.removeClass('active');
        active.addClass('active');

        var lastActiveSub = $('.navbar').find('.menu-second-level.active');
        lastActiveSub.removeClass('active');

        const target = active.data('show-target');
        var lastActiveLastLevel = $('.navbar').find('.submenu-last-level.active');
        if (target.includes('submenu-last-level')) {
          showLevel3Menu(lastActiveLastLevel, $(target));
        } else {
          lastActiveLastLevel.slideUp(animationTime, function() {
            $(this).removeClass('active');
            $(this).css('display', '');
          });
          $(target).addClass('active');
        }
      }

      const onSecondLevelHover = function(e) {
        var lastActive = $('.navbar').find('.menu-second-level .nav-item.active');
        var active = $(this);

        lastActive.removeClass('active');
        active.addClass('active');

        var lastActiveSub = $('.navbar').find('.submenu-last-level.active');
        const target = active.data('show-target');
        showLevel3Menu(lastActiveSub, $(target));
      }

      $('.navbar .nav-link').on('mouseenter', onTopLevelHover);
      // second level hover
      $('.navbar .menu-second-level .nav-item').on('mouseenter', onSecondLevelHover);
      $('nav.navbar').on('mouseleave', function() {
        closeLevel3Menu();
        $('.navbar').find('.nav-link:first').trigger("mouseover");
      });
      $('.navbar .search input').on('focus', function() {
        closeLevel3Menu();
        $('.navbar').find('.nav-link:first').trigger("mouseover");
      });
    });
  }
}

GLOBO.durabilityBreakdown = {
  switchTo: function(target) {
    jQuery('.img-point').removeClass('active');
    jQuery('.point-info').removeClass('active');
    jQuery('.img-point-' + target).addClass('active');
    jQuery('.point-info-' + target).addClass('active');
  }
}

GLOBO.experiment = {
  noVariantSelectedExperiment: false
}

GLOBO.onReady = {
  init: function() {
    GLOBO.header.init();
    GLOBO.swatch.init();
    GLOBO.lang.init();
    // if (typeof customFilters !== 'undefined' && !customFilters.active) {
    //   customFilters.init();
    //   GLOBO.collectionLoader.init();
    // }
    if (typeof WELCOME !== "undefined") {
      WELCOME.loader.init();
    }
    GLOBO.tooltips.init();
    GLOBO.intercom.checkUrl();

    // Optimize.
  //   gtag('event', 'optimize.callback', {
  //     name: 'HSMXq0fpQ1CadDTg03EnfA',
  //     callback: function(value) {
  //       if (value === "1" || value === 1) {
  //         GLOBO.experiment.noVariantSelectedExperiment = true;
  //         var cardBtns = document.querySelectorAll('.product-card-form-btn');
  //         for (var i = 0; i < cardBtns.length; i++) {
  //           cardBtns[i].innerHTML = "Voir Produit";
  //         }
  //       }
  //     }
  //  });
  }
};


GLOBO.onScriptLoad = {
  jQuery: function() {
    jQuery(function($) {
      GLOBO.onReady.init();
    });
  },
  customFilters: function() {
    jQuery(function($) {
      customFilters.init();
      GLOBO.collectionLoader.init();
    });
  }
}

GLOBO.lazyLoad.init();
